import styled, { css } from 'styled-components';
import { Box, SideSheetHeader } from '@bechtel/gds';

export const EditRequestBoxStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
  py: { sm: '300' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.bechtel.blue[700]};
    height: ${theme.spacings[700]};
    gap: ${theme.spacings[200]};
    cursor: pointer;
  `}
`;

export const SideSheetHeaderStyled = styled(SideSheetHeader)`
  border: none;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
`;
